
import { Result } from "../model/Result";
import axiosCilent from "./axiosClient";

const strage = sessionStorage;

const jwtApi = {
  requestGetJwt: async (email: string, authUid: string, tenantId: string): Promise<Result> =>  {
    try {
      return await axiosCilent.post(`getJwt`, {email, authUid, tenantId}, {timeout: 0}).then((resolve) => {
        strage.setItem("jwt", resolve.data.data);
        return resolve.data;
      }).catch((reject) => {
        return {success: false, data: reject};
      });
    } catch (error) {
      return {success: false, data: error};
    }
  },
};

export default jwtApi;
